import React, { useState } from 'react';
import { usePortal } from '../../contexts/PortalContext';
import { BUTTON_QUIET, BUTTON_SOLID, FIELD } from './adminStyles';

/** Understated account panel for the signed-in Portal staff member. */
export function StaffAccount({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    staffUser,
    staffChangePassword,
    notify
  } = usePortal();
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError('');
    const result = await staffChangePassword(current, password, confirm);
    if (!result.ok) {
      setError(result.error ?? 'Something went wrong.');
      return;
    }
    notify('Password updated');
    onClose();
  }
  return <section aria-labelledby="staff-account" className="border-b border-ruleDark" data-id="element-355" data-mp="2pwq88nzis1a4">
      <div className="mx-auto max-w-portal px-6 py-10 sm:px-10" data-id="element-356" data-mp="2kyy7r5kt76ub">
        <div className="flex flex-wrap items-baseline justify-between gap-4" data-id="element-357" data-mp="jql8d1lhx55f">
          <h2 id="staff-account" className="label m-0 text-paper/40" data-id="element-358" data-mp="oon34jsaaswq">
            Account
          </h2>
          <p className="label-sm m-0 text-paper/30" data-id="element-359" data-mp="sqqfrbqow3jl">{staffUser?.email}</p>
        </div>

        <form onSubmit={submit} className="mt-8" data-id="element-360" data-mp="xh6ur0a5rx82">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3" data-id="element-361" data-mp="xi03u7wlaytd">
            <label className="block" data-id="element-362" data-mp="12gt8rbxt9hhx">
              <span className="label block text-paper/40" data-id="element-363" data-mp="12frtswdocaux">Current Password</span>
              <input type="password" value={current} onChange={event => setCurrent(event.target.value)} autoComplete="current-password" className={FIELD} data-id="element-364" data-mp="17ebkfa37qatm" />
            </label>
            <label className="block" data-id="element-365" data-mp="3e63zyiy2vc3y">
              <span className="label block text-paper/40" data-id="element-366" data-mp="3e75i17digyv6">New Password</span>
              <input type="password" value={password} onChange={event => setPassword(event.target.value)} autoComplete="new-password" className={FIELD} data-id="element-367" data-mp="3i6nwbkatubp1" />
            </label>
            <label className="block" data-id="element-368" data-mp="ydngyp1bnywk">
              <span className="label block text-paper/40" data-id="element-369" data-mp="yeopomuv89b4">Confirm New Password</span>
              <input type="password" value={confirm} onChange={event => setConfirm(event.target.value)} autoComplete="new-password" className={FIELD} data-id="element-370" data-mp="ubsfnkje5lis" />
            </label>
          </div>

          {error && <p role="alert" className="label-sm mt-7 text-paper" data-id="element-371" data-mp="1i0l3sutrup2u">
              {error}
            </p>}

          <div className="mt-9 flex flex-wrap items-center gap-6" data-id="element-372" data-mp="1d3usekswwhnr">
            <button type="submit" className={BUTTON_SOLID} data-id="element-373" data-mp="1r1rolg3gem1w">
              Update Password
            </button>
            <button type="button" onClick={onClose} className={BUTTON_QUIET} data-id="element-374" data-mp="1m3znpwktzplk">
              Close
            </button>
          </div>
        </form>
      </div>
    </section>;
}